import { motion } from 'framer-motion';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-teal-950/20 to-slate-900 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <div className="flex justify-center mb-4">
            <div className="relative">
              <img
                src="/pwa-192x192.png"
                alt="Agos Logo"
                className="h-12 w-12 object-contain hover:scale-110 transition-transform"
              />
              <div className="absolute inset-0 bg-teal-500/20 blur-lg hover:bg-teal-400/30 transition-all" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-white">Terms of Service</h1>
          <p className="mt-4 text-gray-300">Last updated: March 14, 2024</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="prose prose-invert max-w-none"
        >
          <div className="glass-card p-8 rounded-lg">
            <h2 className="text-2xl font-bold text-white mb-6">1. Acceptance of Terms</h2>
            <p className="text-gray-300 mb-8">
              By accessing and using Agos's services, you agree to be bound by these Terms of Service and all applicable laws and regulations.
            </p>

            <h2 className="text-2xl font-bold text-white mb-6">2. Description of Service</h2>
            <p className="text-gray-300 mb-8">
              Agos provides secure identity verification services. We reserve the right to modify or discontinue any aspect of our service at any time.
            </p>

            <h2 className="text-2xl font-bold text-white mb-6">3. User Responsibilities</h2>
            <ul className="list-disc pl-6 text-gray-300 mb-8">
              <li>Maintain the security of your account credentials</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Use the service only for lawful purposes</li>
              <li>Not attempt to circumvent any security measures</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-6">4. Payment Terms</h2>
            <p className="text-gray-300 mb-8">
              Users agree to pay all fees according to the pricing plan they select. Fees are non-refundable except as required by law.
            </p>

            <h2 className="text-2xl font-bold text-white mb-6">5. Intellectual Property</h2>
            <p className="text-gray-300 mb-8">
              All content and functionality on the service is the exclusive property of Agos and protected by copyright and other intellectual property laws.
            </p>

            <h2 className="text-2xl font-bold text-white mb-6">6. Limitation of Liability</h2>
            <p className="text-gray-300 mb-8">
              Agos shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.
            </p>

            <h2 className="text-2xl font-bold text-white mb-6">7. Changes to Terms</h2>
            <p className="text-gray-300 mb-8">
              We reserve the right to modify these terms at any time. Continued use of the service constitutes acceptance of modified terms.
            </p>

            <h2 className="text-2xl font-bold text-white mb-6">8. Contact Information</h2>
            <p className="text-gray-300">
              For questions about these Terms of Service, please contact us at:
              <br />
              <a href="mailto:legal@agosidentity.com" className="text-teal-400 hover:text-teal-300">
                legal@agosidentity.com
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}